import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'playerTrends', 'teamTrends', 'additionalInfo' ]

  connect() {
    // console.log("Hello, Game Additional Info Controller here!", this.element)
  }

  submitForm(event) {
    event.preventDefault();
    // console.log("Submitting form", event.target);

    // we disable the checkbox because once its a game fact, they have to delete it to remove it
    event.target.disabled = true;

    event.target.form.requestSubmit();
  }

}
